const loadPromises = new Map();

const ensureScriptLoaded = (id, url) => {
    const tracked = loadPromises.get(id);

    if (tracked) {
        return tracked;
    }

    // Present but untracked: assume it already executed. Safe only for finished scripts — do not server-render a <script> with one of these ids.
    if (document.getElementById(id)) {
        const ready = Promise.resolve();
        loadPromises.set(id, ready);

        return ready;
    }

    const promise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.id = id;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () => {
            loadPromises.delete(id);
            reject(new Error(`Failed to load external script: ${url}`));
        });
        document.head.appendChild(script);
    });

    loadPromises.set(id, promise);

    return promise;
};

export const loadExternalScript = async (id, url, callback = () => {}) => {
    await ensureScriptLoaded(id, url);

    return callback();
};
